import api from './api';
import { Admin } from '../types';

export const adminAuthService = {
  async login(email: string, password: string): Promise<{ admin: Admin; token: string }> {
    const response = await api.post('/admin/auth/login', { email, password });
    return response.data;
  },

  async verifyToken(token: string): Promise<Admin> {
    const response = await api.get('/admin/auth/me', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  async refreshToken(): Promise<{ token: string }> {
    const response = await api.post('/admin/auth/refresh');
    return response.data;
  },
};
